"use strict";
exports.__esModule = true;
exports.legendMobileDialogAlignPoints = exports.legendDialogAlignPoints = void 0;
exports.legendDialogAlignPoints = [
    {
        align: "tr tl",
        offset: {
            x: 18,
            y: 0
        }
    },
    {
        align: "tl tr",
        offset: {
            x: -18,
            y: 0
        }
    },
    {
        align: "br bl",
        offset: {
            x: 18,
            y: 0
        }
    },
    {
        align: "bl br",
        offset: {
            x: -18,
            y: 0
        }
    },
    {
        align: "bc tc",
        offset: {
            x: 0,
            y: 18
        }
    },
    {
        align: "cc cr",
        offset: {
            x: -200,
            y: 0
        }
    },
];
exports.legendMobileDialogAlignPoints = [
    {
        align: "bc tc",
        offset: {
            x: 0,
            y: -40
        }
    },
    {
        align: "tc bc",
        offset: {
            x: 0,
            y: -18
        }
    },
    {
        align: "cc tc",
        offset: {
            x: 0,
            y: 0
        }
    },
];
//# sourceMappingURL=alignPoints.js.map